import styled from 'styled-components';

import { EmptyStateWrapper as BaseEmptyStateWrapper, HeaderText as BaseHeaderText } from './base';

export * from './base';

export const EmptyStateWrapper = styled(BaseEmptyStateWrapper)`
  color: ${Styles.color.black};
  padding: 0 2rem;

  ${Styles.mobileTiny`
    padding: 0;
  `}
`;

export const HeaderText = styled(BaseHeaderText)`
  font-family: ${Styles.fontFamily.base};
  font-weight: normal;
`;
